/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'
import { get } from 'lodash'
/**
 * Import
 * - Store
 */
import { RootState } from '../../../store'

/**
 * Import
 * - Actions
 */
import {
    issueViewQuoteVariation,
    bindQuoteVariation,
    getQuoteSingle,
    handleReissueQuote,
    confirmEditQuote,
    fetchLocations,
} from '../../../actions'

/**
 * Import
 * - Page component
 */
import ViewQuote from '../../../components/pages/Quote/ViewQuote/ViewQuote'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        quote: state.quotesSingle,
        step05: state.step05,
        step05Bind: state.quote.step05,
        riskLocations: state.quote.riskLocations,
        isCollectors: get(state, 'quotesSingle.response.isCollectors', false),
        isMuseums: get(state, 'quotesSingle.response.isMuseums', false),
        isDealersStock: get(state, 'quotesSingle.response.isDealersStock', false),
    }
}

export default connect(
    mapStateToProps,
    {
        issueViewQuoteVariation: issueViewQuoteVariation,
        bindQuoteVariation: bindQuoteVariation,
        handleReissueQuote: handleReissueQuote,
        getQuoteSingle: getQuoteSingle,
        confirmEditQuote,
        fetchLocations,
    }
)(ViewQuote)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Quote/ViewQuote.tsx